import { useMemo } from "react";
import type { DiscoverItem } from "../types";
import { useDiscoverContext, useDiscoverItems } from "../state/discover-context";

export function useLikedItems(): DiscoverItem[] {
  const { state } = useDiscoverContext();
  const items = useDiscoverItems();
  return useMemo(
    () => items.filter((item) => state.likedIds.has(item.id)),
    [items, state.likedIds],
  );
}
